export default __webpack_public_path__ + "static/media/beautiful-girl-sitting-dentist-s-office.20dac102.jpg";